import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface SpendCategoryOption {
    id: string;
    title: string;
    isDeleted: boolean;
}

export const fetchSpendCategoryOptions = createAsyncThunk<
    SpendCategoryOption[],
    { propertyIds?: string[] },
    ThunkConfig<string>
>(
    'reportSpendSummary/fetchSpendCategoryOptions',
    async ({ propertyIds }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const response = await extra.api.post<{
                items: SpendCategoryOption[];
            }>('/v1/reports/spend-insights/category-options', {
                ...(propertyIds?.length ? { propertyIds } : {}),
            });
            return response.data.items ?? [];
        } catch {
            return rejectWithValue('error');
        }
    },
);
